export default {
    getTokenApi: '/sts/authorization',
    getCaseListApi: '/cases/list',
    uploadCaseInfo: '/cases',
    getCollectListApi: '/cases/my_favorites',
    getUploadListApi: '/cases/my_uploads',
    getAdtype: '/enumtype/adtype',
    getApmtype: '/enumtype/apm',
    getLauchIndustry: '/enumtype/lauchIndustry',
    getLauchPurpose: '/enumtype/lauchPurpose',
    getOtherTags: '/enumtype/otherTags',
    getDetail: '/cases/{id}',
    getComments: '/comments',
    addComments: '/{id}/comments',
    collectCase: '/cases/{id}/favorites',
    cancelCollect: '/cases/{id}/unfavorites',
    getDownloadUrl: '/cases/{id}/download',
    getBussniessAll: '/getCustomerBussniessAll',
    getCustomerBussniess: '/casesharing/business_class/{id}',
    getCIDName: '/casesharing/cid/list',
    getCustName: '/casesharing/customer_name/list',
    getIntegral: '/cases/my_points',
    reduceIntegral: '/cases/my_points'
}
